import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CollectionComponetTypesActions,
  FlowsActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';

import { ComponentTypeForm } from '../components/ComponentTypeForm';

export const CreateCollectionComponentsComponentTypePage = () => {
  const { pageId } = useParams<{ pageId: string }>();

  const navigate = useNavigate();

  const contentDispatch = useContentDispatch();

  const collectionComponent = useContentSelector(
    ({ collectionComponents }) => collectionComponents.details
  );

  const basePathname = `/collection-components/${pageId}/components`;

  return (
    <div className="p-10">
      <div>
        <ComponentTypeForm
          type="Create"
          onSubmit={async (componentTypeId) => {
            const res = await contentDispatch(
              CollectionComponetTypesActions.addAllowedTypeAsync({
                containerCollectionComponentTypeId: collectionComponent?.typeId,
                allowedComponentTypeId: componentTypeId,
              })
            );

            if (res.meta.requestStatus === 'fulfilled') {
              navigate(
                `${basePathname}/new?componentTypeId=${componentTypeId}`
              );
            }
          }}
          onCancel={() => {
            navigate(`${basePathname}/new`);
          }}
        />
      </div>
    </div>
  );
};
